import React, { Component } from 'react';
import { connect } from "react-redux";
import { BsShieldLockFill } from "react-icons/bs";
import { userActions } from '../../_actions';

class UserLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentView: 'login',
      email: '',
      otp: ['', '', '', '', '', ''],
    };
  }

  // Handle Email Change
  handleEmailChange = (e) => {
    this.setState({ email: e.target.value });
  };

  // Continue with Email
  handleContinueWithEmail = (e) => {
    e.preventDefault();

    const { email } = this.state;

    if (email) {
      this.setState({ currentView: 'otp' });

      this.props.dispatch(
        userActions.userCoachSignIn({ email }, this.props)
      );
    }
  };

  // Handle OTP Typing
  handleOtpChange = (element, index) => {
    const value = element.value;

    // Allow only numbers
    if (!/^\d*$/.test(value)) return;

    let updatedOtp = [...this.state.otp];
    updatedOtp[index] = value;

    this.setState({ otp: updatedOtp }, () => {
      // Move to next input
      if (value !== "" && element.nextSibling) {
        element.nextSibling.focus();
      }
    });
  };

  // Handle Backspace Navigation
  handleKeyDown = (e, index) => {
    if (
      e.key === "Backspace" &&
      this.state.otp[index] === "" &&
      e.target.previousSibling
    ) {
      e.target.previousSibling.focus();
    }
  };

  // Handle Paste OTP
  handlePaste = (e) => {
    e.preventDefault();

    const pastedData = e.clipboardData.getData("text").trim();

    // Allow only numbers
    if (!/^\d+$/.test(pastedData)) return;

    const otpDigits = pastedData.slice(0, 6).split("");

    let updatedOtp = [...this.state.otp];

    otpDigits.forEach((digit, index) => {
      updatedOtp[index] = digit;
    });

    this.setState({ otp: updatedOtp }, () => {
      // Focus last filled input
      const inputs = document.querySelectorAll(".otp-input");

      if (inputs.length) {
        const lastIndex = Math.min(otpDigits.length - 1, 5);
        inputs[lastIndex].focus();
      }
    });
  };

  // Verify OTP
  handleVerifyOtp = (e) => {
    e.preventDefault();

    const joinedOtp = this.state.otp.join('');

    if (joinedOtp.length === 6) {
      this.OTPSubmit(joinedOtp);
    }
  };

  // Submit OTP
  OTPSubmit = (otp_code) => {
    const { user } = this.props;
    const {
      UserAssessmentEmailToken,
      UserAssessmentType
    } = user;

    const data = {
      token: UserAssessmentEmailToken,
      otp: otp_code,
    };

    if (UserAssessmentType) {
      this.props.dispatch(
        userActions.userCoachValidateOtp(data, this.props)
      );
    } else {
      this.props.dispatch(
        userActions.userAssessmentValidateOtp(data, this.props)
      );
    }
  };

  // Change Email
  handleChangeEmail = () => {
    this.setState({
      currentView: 'login',
      otp: ['', '', '', '', '', '']
    });
  };

  render() {
    const { currentView, email, otp } = this.state;

    return (
      <div className="min-h-screen bg-white flex flex-col lg:flex-row font-sans">

        {/* Left Panel */}
        <div className="w-full lg:w-[50%] bg-[#edf5ff] relative overflow-hidden flex flex-col justify-between p-8 lg:p-16 min-h-[300px] lg:min-h-screen">
          <img src="/welcome/insightplus-services.png" alt="Banner" className="absolute inset-0 w-full h-full object-cover z-0 object-center" />
        </div>

        {/* Right Panel */}
        <div className="w-full lg:w-[50%] flex flex-col justify-between p-8 lg:p-16 bg-white min-h-[550px]">

          <div className="my-auto max-w-md w-full mx-auto">

            {/* Login View */}
            {currentView === 'login' && (
              <div>
                <h3 className="text-3xl lg:text-4xl font-extrabold text-slate-900 mb-2">Welcome back!</h3>
                <h4 className="text-2xl font-bold text-slate-800 mb-1">Sign in</h4>
                <p className="text-xs text-slate-500 italic mb-8">Enter your email address to receive a verification code.</p>

                <form onSubmit={this.handleContinueWithEmail} className="space-y-5">
                  <div>
                    <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-2">Email Address</label>
                    <input type="email" required value={email} onChange={this.handleEmailChange} placeholder="Email address" className="w-full px-4 py-3.5 border border-slate-200 rounded-lg" />
                  </div>
                  <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3.5 rounded-lg">  Continue with Email</button>
                </form>

                <div className="flex items-center justify-center space-x-4 mt-8 text-xs text-slate-400 font-medium">
                  <span className="flex items-center">
                    <BsShieldLockFill size={20} className="mr-1" />
                    Secure login
                  </span>
                  {/* <span>•</span> */}
                  {/* <span className="flex items-center">
                    <BsShieldLockFill size={20} className="mr-1" />
                    Secure login
                  </span> */}
                </div>
              </div>
            )}

            {/* OTP View */}
            {currentView === 'otp' && (
              <div>
                <h3 className="text-3xl lg:text-4xl font-extrabold text-slate-900 mb-3">Verification</h3>

                <div className="text-sm text-slate-500 mb-8 flex flex-wrap items-center">
                  <span className="italic mr-1">We have sent 6 digit OTP to:</span>
                  <strong className="text-slate-700 mr-2">{email}</strong>
                  <button onClick={this.handleChangeEmail} className="text-blue-600 text-xs underline">Change</button>
                </div>

                <form onSubmit={this.handleVerifyOtp} className="space-y-6">
                  <div>
                    <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-3">Verify OTP</label>
                    <div className="grid grid-cols-6 gap-3">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          type="text"
                          maxLength="1"
                          value={digit}
                          onChange={(e) =>
                            this.handleOtpChange(e.target, index)
                          }
                          onKeyDown={(e) =>
                            this.handleKeyDown(e, index)
                          }
                          onPaste={this.handlePaste}
                          onFocus={(e) => e.target.select()}
                          className="otp-input w-full h-12 text-center text-lg font-bold text-slate-800 bg-white border border-slate-200 rounded-lg focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600"
                        />
                      ))}

                    </div>
                  </div>

                  <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3.5 rounded-lg">  Verify</button>
                </form>

                <div className="flex items-center justify-between mt-10 pt-4 border-t border-slate-100">
                  <span className="text-sm font-semibold text-slate-700">  Didn't receive OTP?</span>
                  <button type="button" className="px-4 py-2 text-xs font-semibold text-blue-600 border border-slate-200 rounded-lg">  Resend OTP</button>
                </div>
              </div>
            )}
          </div>
          <div className="text-center text-[11px] text-slate-400 mt-8">All Rights Reserved | Copyright © 2026 InsightPlus.</div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state;
  return { user };
}

export default connect(mapStateToProps)(UserLogin);